export const NICKNAME_MIN_LENGTH = 5;
export const NICKNAME_MAX_LENGTH = 255;
export const NICKNAME_PATTERN: RegExp = /^(?!\d+$)[A-Za-z0-9._-]+$/;

export const isNicknamePatternValid = (value: string): boolean => {
  const nickname = value.trim();
  if (nickname.length < NICKNAME_MIN_LENGTH) return false;
  if (nickname.length > NICKNAME_MAX_LENGTH) return false;
  return NICKNAME_PATTERN.test(nickname);
};
